import { Component } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { BookingDataContainer, UserData, GeneralBookingModel } from "../../model/index"
import { PortalMobileOtpModel } from "../../Model/Booking/PortalMobileOtpModel";
declare let CryptoJS: any;
@Component({
    providers: [Http]
})
export class BookingService {
    private _getMobileOtpUrl: string = "/api/booking/SendAndVerifyOtp";
    private _bookingServiceurl: string = "/api/booking/list";

    private _bookingServiceGuesturl: string = "/api/booking/Guestlist";
    private _bookingServiceSearchGuesturl: string = "/api/booking/SearchGuestlist";
    private _bookingServiceSearchBookingurl: string = "/api/booking/SearchBookinglist";
    private _deptServiceurl: string = "/api/booking/dept";

	private _deptGuestServiceurl: string = "/api/booking/Guestdept";

    private _confirmBookingUrl: string = "/api/booking/ConfirmBooking";

    private _chosenSlotDetailUrl: string = "/api/booking/ChosenSlotDetail";

    private _chosenSlotDetailGuestUrl: string = "/api/booking/ChosenSlotDetailGuest";
    private _paymentModeSelectionGuestUrl: string = "/api/booking/PaymentModeSelectionGuest";
    
    private _confirmBookingGuestUrl: string = "/api/booking/ConfirmBookingGuest";

    private _saveAppointmentUrl: string = "/api/booking/SaveAppointment"; 

	private _saveAppointmentGuestUrl: string = "/api/booking/SaveAppointmentGuest"; 

    private _bookedSlotDetailsUrl: string = "/api/booking/BookedSlotDetails"; 

    private _AfterPaymentConfirmationUrl: string = "/api/booking/AfterPaymentConfirmation";
    private _AfterPaymentConfirmationGuestUrl: string = "/api/booking/AfterPaymentConfirmationGuest";

    private _slotAndLocDetailsUrl: string = "api/booking/SlotAndLocDetails";

    private _splittedTimeSlots: string = "api/booking/SplittedTimeSlots";

	private _payLaterAppointmentSave: string = "api/booking/PayLaterAppointmentSave"; 

    private _locaGuestServiceurl: string = "/api/booking/GuestLocation";

    constructor(private _http: Http) {
    }

    public getDepartments(userInfo: UserData, locationId: string): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);
        let body: string = JSON.stringify(locationId);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._deptServiceurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public getDepartmentsGuest(userInfo: UserData, locationId: string): Observable<BookingDataContainer> {
         var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);
        let body: string = JSON.stringify(locationId);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._deptGuestServiceurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public AfterPaymentConfirmationGuest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body = JSON.stringify(bookingDataModel);
         let headers: Headers = new Headers({ "Content-Type": "application/json" });
         var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
         headers.append("__RequestVerificationToken", antiForgeryToken);
         headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
         let options: RequestOptions = new RequestOptions({ headers: headers });

         let data$ = this._http.post(this._AfterPaymentConfirmationGuestUrl, body, options)
             .map(res => res.json())
             .catch(this.handleError);
         return data$;
     }


    public getBookingReports(userInfo: UserData): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);

        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }


    public GetSplittedTimeSlots(userInfo: UserData, bookingDataModel: GeneralBookingModel) {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);

        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._splittedTimeSlots, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    public getBookingReportsGuest(userInfo: UserData): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);

        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceGuesturl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }
    
    public SearchBookingReportsBooking(userInfo: UserData): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);
        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceSearchBookingurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public SearchBookingReportsGuest(userInfo: UserData): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);

        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceSearchGuesturl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }
    public getFilterReports(userInfo: UserData): Observable<BookingDataContainer> {
        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public getFilterReportsForGuest(userInfo: UserData): Observable<BookingDataContainer> {
        let body: string = JSON.stringify(userInfo);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._bookingServiceGuesturl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }

    public getConfirmBookingStatus(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$  = this._http.post(this._confirmBookingUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    public getConfirmBookingStatusGuest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._confirmBookingGuestUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }


    public updateChosenSlot(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._chosenSlotDetailUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

	 public updateChosenSlotGuest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._chosenSlotDetailGuestUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

     public PaymentModeSelectionGuest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
         let body: string = JSON.stringify(bookingDataModel);
         let headers: Headers = new Headers({ "Content-Type": "application/json" });
         var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
         headers.append("__RequestVerificationToken", antiForgeryToken);
         headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
         let options: RequestOptions = new RequestOptions({ headers: headers });

         let data$ = this._http.post(this._paymentModeSelectionGuestUrl, body, options)
             .map(res => res.json())
             .catch(this.handleError);
         return data$;
     }


    public SaveApointmentRequest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._saveAppointmentUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }
   
    public SaveAppointmentGuest(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._saveAppointmentGuestUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }
   
    public AfterPaymentConfirmationdata(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._AfterPaymentConfirmationUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    public AfterPaymentConfirmation(patientId: string, userInfo: UserData) {
        let body = JSON.stringify(patientId);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._AfterPaymentConfirmationUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }

    public RedirectToPaytabs(PaymentRedirectSiteUrl: string, userId: string, pid: string, authentication: string, isAdmin: boolean) {
        var userData: UserData = new UserData(userId, pid, authentication, isAdmin);

        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userId + ":" + authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(PaymentRedirectSiteUrl, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }  

	
    public PayLaterAppointmentSave(bookingDataModel: GeneralBookingModel, userInfo: UserData) {
        let body: string = JSON.stringify(bookingDataModel);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$ = this._http.post(this._payLaterAppointmentSave, body, options)
            .map(res => res.json())
            .catch(this.handleError);
        return data$;
    }	

    private handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || "";
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg || " API Server Error");
    }


    public SendAndVerifyOtp(userInfo: UserData, _SLNO: string, _HOSPITALNO: string, _MOBILENO: string, _OTP: string): Observable<PortalMobileOtpModel> {

        var key = CryptoJS.enc.Utf8.parse(localStorage.getItem("SecureValue"));
        var iv = CryptoJS.enc.Utf8.parse(localStorage.getItem("SecureValue"));
        var encryptedMobileNo = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(_MOBILENO), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        var encryptedPid = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(_HOSPITALNO), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        var encryptedOtp = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(_OTP), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
        var patientId: string = encryptedPid.toString();
        var mobileNo: string = encryptedMobileNo.toString();
        var otp: string = encryptedOtp.toString();
        var userData: PortalMobileOtpModel = new PortalMobileOtpModel(_SLNO, patientId, mobileNo, otp);
        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<PortalMobileOtpModel> = this._http.post(this._getMobileOtpUrl, body, options)
            .map(res => <PortalMobileOtpModel>res.json())
            .catch(this.handleError);
        return data$;
    }

    public getLocationGuest(userInfo: UserData): Observable<BookingDataContainer> {
        var userData: UserData = new UserData(userInfo.User, userInfo.Authentication, userInfo.pid, userInfo.IsAdminUser);
        let body: string = JSON.stringify(userData);
        let headers: Headers = new Headers({ "Content-Type": "application/json" });
        var antiForgeryToken = $("input[name=__RequestVerificationToken]").val();
        headers.append("__RequestVerificationToken", antiForgeryToken);
        headers.append("MentisSoftAuthorization", "Basic " + btoa(userInfo.User + ":" + userInfo.Authentication));
        let options: RequestOptions = new RequestOptions({ headers: headers });

        let data$: Observable<BookingDataContainer> = this._http.post(this._locaGuestServiceurl, body, options)
            .map(res => <BookingDataContainer>res.json())
            .catch(this.handleError);
        return data$;
    }
} 


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Booking/service/booking.service.ts